import { render, staticRenderFns } from "./PageOutline.vue?vue&type=template&id=63cd8a02&"
import script from "./PageOutline.vue?vue&type=script&lang=js&"
export * from "./PageOutline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\DigitalCreditTransfer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63cd8a02')) {
      api.createRecord('63cd8a02', component.options)
    } else {
      api.reload('63cd8a02', component.options)
    }
    module.hot.accept("./PageOutline.vue?vue&type=template&id=63cd8a02&", function () {
      api.rerender('63cd8a02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/PageOutline.vue"
export default component.exports